import { MessageBar, MessageBarType } from "@fluentui/react";
import Form from "antd/lib/form/Form";
import { Formik } from "formik";
import React, { createContext, useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import SettingStore from "../store/ebendosettingstore";
import { toJS } from "mobx";
import FormItem from "antd/lib/form/FormItem";
import { Button, Divider, Input, notification, Tooltip } from "antd";
import moment from "moment";
import "../style/settings.css";
const settingStorectx = createContext(SettingStore);
export const EbendoDailySettings = observer(() => {
  const settingStore = useContext(settingStorectx);
  useEffect(() => {
    async function loadSettings() {
      try {
        await settingStore.loadEbendoSettings();
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
    }
    loadSettings();
  }, []);

  return (
    <div className="ms-Grid" dir="ltr" style={{ padding: "5px" }}>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm9">
          <SubPageHeaderTitle title="EBENDO Field Production Input Deck Configurations" />
          <div>Excel Worksheet Cell Address</div>
        </div>
        <div className="ms-Grid-col ms-sm3" style={{ textAlign: "right" }}>
          <Button
            type="primary"
            disabled={!settingStore.isSettingsModified}
            loading={settingStore.isSaving}
            onClick={async () => {
              try {
                const res = await settingStore.saveEbendoSettings();
                if (res.success) {
                  settingStore.isSettingsModified = false;
                  settingStore.ebendoSettings = res.setting;
                  settingStore.isSaving = false;
                  notification.success({
                    message: "SPARS Feedback",
                    description:
                      "Ebendo input deck settings modification saved successfully",
                  });
                }
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: `download failed,${error.message}`,
                });
              } finally {
                settingStore.isSaving = false;
              }
            }}
          >
            Save Modifiations
          </Button>
        </div>
      </div>

      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <MessageBar messageBarType={MessageBarType.warning}>
            Ensure you map correctly , the production field entries with
            respective current worksheet cell addresses.Any mapping error would
            cause values extractions failure thereby preventing the template to
            preview and upload
          </MessageBar>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Formik
            initialValues={toJS(settingStore.ebendoSettings)}
            enableReinitialize={true}
          >
            {({ values }) => (
              <Form
                layout="horizontal"
                labelAlign="left"
                style={{ background: "#fff", padding: "10px" }}
              >
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <Divider>Production Figures</Divider>

                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title="Net Production (bopd)">
                        {" "}
                        <FormItem
                          label="Oil (bopd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ width: "200px" }}
                            name="oil"
                            value={values?.oil}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.oil = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title="Station Water Production (bwpd)">
                        <FormItem
                          label="Water (bwpd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="water"
                            value={values?.water}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.water = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>

                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title="Condensate from Gas Plant (bopd) ">
                        <FormItem
                          label="Condensate (bopd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="condensate"
                            value={values?.condensate}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.condensate = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title="Station Gas Production (Mmscfd)">
                        <FormItem
                          label="Gas (Mmscfd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="gas"
                            value={values?.gas}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.gas = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>

                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title="Fuel Gas Consumed in Operations (Mmscfd)">
                        <FormItem
                          label="Fuel Gas (Mmscfd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="fuelGas"
                            value={values?.fuelGas}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.fuelGas = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title="Total  Flared Gas (Mmscfd)">
                        <FormItem
                          label="Total  Flared (Mmscfd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="flareGas"
                            value={values?.flareGas}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.flareGas = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <Divider>Evacuation Figures</Divider>
                    <div className="ms-Grid-col ms-sm4">
                      <Tooltip title="Crude injection to GGF(bbls)">
                        <FormItem
                          label="Crude injection to GGF(bbls)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="crudeInjectionGGF"
                            value={values?.crudeInjectionGGF}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.crudeInjectionGGF = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                    <div className="ms-Grid-col ms-sm4">
                      <Tooltip title="Total Gas Supplied  To gas Plant (Mmscfd) ">
                        <FormItem
                          label="Gas supplied to Gas plant(Mmscfd)"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="gasSuppliedToGasPlant"
                            value={values?.gasSuppliedToGasPlant}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.gasSuppliedToGasPlant = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <Divider>Other Station Figures</Divider>
                    <div className="ms-Grid-col ms-sm4">
                      <FormItem
                        label="Production Refer Date"
                        labelAlign="left"
                        className="add-border"
                      >
                        <Input
                          style={{ width: "80px" }}
                          name="productionDate"
                          value={settingStore.ebendoSettings?.productionDate}
                          onChange={({ target }) => {
                            settingStore.ebendoSettings.productionDate =
                              target.value;
                          }}
                        />
                      </FormItem>
                    </div>

                    <div className="ms-Grid-col ms-sm4">
                      <Tooltip title="Station API (@60 degF) ">
                        <FormItem
                          label="Station API (@60 degF)"
                          labelAlign="left"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="stationAPI"
                            value={values?.stationAPI}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.stationAPI = value;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <Divider>Well Contributions Figures (Table)</Divider>
                    <div>
                      <span style={{ color: "red", fontStyle: "italic" }}>
                        Includes the well contibutions tables headers (Well,Well
                        line up,Choke X/64" e.t.c)
                      </span>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title=" Row Start  Table Cell Address  ">
                        {" "}
                        <FormItem
                          label="Row Start"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="rowStart"
                            value={values?.rowStart}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.rowStart = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title=" Row End Table Cell Address    ">
                        {" "}
                        <FormItem
                          label="Row End"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="rowEnd"
                            value={values?.rowEnd}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.rowEnd = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title=" Column Start Table Cell Address     ">
                        {" "}
                        <FormItem
                          label="Column Start "
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="colStart"
                            value={values?.colStart}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.colStart = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                    <div className="ms-Grid-col ms-sm3">
                      <Tooltip title=" Column End Table Cell Address    ">
                        {" "}
                        <FormItem
                          label="Column End"
                          labelAlign="left"
                          className="add-border"
                        >
                          <Input
                            style={{ minWidth: "60%" }}
                            name="colEnd"
                            value={values?.colEnd}
                            onChange={({ target: { value } }) => {
                              settingStore.ebendoSettings.colEnd = value;
                              settingStore.isSettingsModified = true;
                            }}
                          />
                        </FormItem>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                      <Divider>Manage Producing Wells</Divider>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm9">
            <MessageBar messageBarType={MessageBarType.info}>
              last modified by {settingStore?.ebendoSettings?.uploadedBy} on{" "}
              {moment(settingStore?.ebendoSettings?.uploadedOn).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
            </MessageBar>
          </div>
        </div>
      </div>
    </div>
  );
});

